import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  sportAnalyticTag,
  useSportContext,
} from '@sorare/core/src/contexts/sport';
import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import { useScoutingCenterSo5Fixture } from '@sorare/marketplace/src/hooks/useScoutingCenterSo5Fixture';
import {
  DROPDOWN_FILTERS_BY_SPORT,
  FILTERS_BY_SPORT,
  SORTS_BY_SPORT,
} from '@sorare/marketplace/src/lib/scoutingCenterFilters';
import { AdvancedPlayerSearch } from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';

import { Header } from '#src/components/scoutingCenter/stats/Header/index.tsx';

export const ScoutingCenter = () => {
  const { sport } = useSportContext();
  const { so5FixtureSlug, loading } = useScoutingCenterSo5Fixture(sport);
  const SORTS = SORTS_BY_SPORT[sport];
  const FILTERS = FILTERS_BY_SPORT[sport];
  const DROPDOWN_FILTERS = DROPDOWN_FILTERS_BY_SPORT[sport];
  return (
    <MarketRoot>
      <Vertical gap={3}>
        <Header sport={sport} />
        <div>
          <AdvancedPlayerSearch
            sport={sport}
            defaultHitsPerPage={20}
            sorts={SORTS}
            defaultSort={SORTS[0]}
            cardFilters={FILTERS}
            dropdownFilters={DROPDOWN_FILTERS}
            analyticsTags={['Scouting-center', sportAnalyticTag[sport]]}
            topic={{ type: 'scoutingCenter', label: '' }}
            attributesToRetrieve={['slug']}
            so5FixtureSlug={so5FixtureSlug}
            shouldSkip={loading}
          />
        </div>
      </Vertical>
    </MarketRoot>
  );
};
